import { Injectable } from '@angular/core';
import { AppCollection } from '../app.config';
import { BaseCollectionService } from '../core/jsonApi/BaseCollectionService';
import { LearningSectionJsonModel } from './learning-section.json.model';

@Injectable({
  providedIn: 'root'
})
export class LearningSectionService extends BaseCollectionService<LearningSectionJsonModel, AppCollection> {
  protected ctor = LearningSectionJsonModel;
}
